module.exports = __webpack_public_path__ + "public/img/ico-overview-expenses.0a0cef99.svg";